fx.ns("shared.stage", class ToolBarAction extends fx.Component{
    
    constructor(command, component, container)
    {
        super();

        this.command = command;
        this.component = component;
        this.container = container;
    }

    onReady(){
        super.onReady();

        this.on("selection-changed", this.selectionChanged, this.component);

        this.on("updated", this.onComponentDataUpdated, this.component.data);

        
    }

    get label()
    {
        return this.command.label;
    }

    get event()
    {
        return this.command.event;
    }

    get field()
    {
        return this.command.field;
    }

    get icon()
    {
        return this.command.icon;
    }

    action(value)
    {
        this.component.trigger("command", {event : this.command.event, field : this.command.field, value : value });
    }

    selectionChanged()
    {

    }

    onDataUpdated(action)
    {
        this.node.innerHTML = this.render();
    }

    onComponentDataUpdated(e)
    {
        
    }


    /*show()
    {
        this.css("display", "inline-block");
    }

    hide()
    {
        this.css("display", "none");
    }*/

});